




















































import { Vue, Component, Prop } from 'vue-property-decorator'
import { IDialog } from '@/model'
import { SendToRobotParameters, PalletPattern, RobotTypeEnum } from '@/generated/model/models'

@Component
export default class SendToRobotDialog extends Vue {
  @Prop() private value: boolean = false
  @Prop() private dialogProps!: IDialog
  @Prop() private selectedPalletPattern!: PalletPattern

  private params: SendToRobotParameters = { server: '192.168.1.13', port: undefined, user: 'flexlink', pwd: '' }
  private ftpTransferModes: any[] = [
    {
      value: undefined,
      text: ''
    },
    {
      value: SendToRobotParameters.FtpTransferModeEnum.ACTIVE.toString(),
      text: 'Active'
    },
    {
      value: SendToRobotParameters.FtpTransferModeEnum.PASSIVE.toString(),
      text: 'Passive',
    }
  ]

  private resolve: any = () => {
    return false
  }

  get show () {
    return this.value
  }

  set show (value) {
    this.$emit('input', value)
  }

  get showSetAsNextActive (): boolean {
    // only show the "Set as next active" check box if robot type is RI20_FANUC. For other robots that check box has no effect.
    const robotType = this.selectedPalletPattern.programSettings ? this.selectedPalletPattern.programSettings.robotType : undefined
    return (robotType === RobotTypeEnum.RI20_FANUC || robotType === RobotTypeEnum.RI20_KUKA)
  }

  private mounted () {
    this.restoreFromCache()
  }

  private cancel () {
    // this.active = false
    this.resolve(false)
  }

  private pop () {
    this.show = true
    return new Promise((resolve, reject) => {
      this.resolve = resolve
    })
  }

  // overwrite parent
  private accept () {
    if (!this.params.ftpTransferMode) {
      // work around for issues with empty string and null
      this.params.ftpTransferMode = undefined
    }
    this.cacheUserInput()
    this.$emit('accept', this.params)
    this.resolve(true)
  }

  private restoreFromCache () {
    try {
      const cachedStr = window.localStorage.getItem('sendToRobotParameters')
      if (cachedStr) {
        const cached: SendToRobotParameters = (JSON.parse(cachedStr ? cachedStr : '{}') as SendToRobotParameters)
        this.params.server = cached.server
        this.params.port = cached.port
        this.params.user = cached.user
        if (cached.pwd) {
          this.params.pwd = window.atob(cached.pwd)
        }
        if (cached.ftpTransferMode) {
          const enumValue = (SendToRobotParameters.FtpTransferModeEnum as any)[cached.ftpTransferMode]
          this.params.ftpTransferMode = enumValue
        }
      }
    } catch (e) {
      console.log('[ERROR] restoreFromCache failed: ', e)
    }
  }

  private cacheUserInput () {
    try {
      const cached = {
        server: this.params.server,
        port: this.params.port,
        user: this.params.user,
        pwd: this.params.pwd ? window.btoa(this.params.pwd) : '',
        ftpTransferMode: this.params.ftpTransferMode ? this.params.ftpTransferMode.toString() : ''
      }
      window.localStorage.setItem('sendToRobotParameters', JSON.stringify(cached))
    } catch (e) {
      console.log('[ERROR] cacheUserInput failed: ', e)
    }
  }

}
